import React, { useState } from "react";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";

const Services = () => {
  const [compareVisible, setCompareVisible] = useState(false);

  return (
    <section className="py-20 bg-gray-100" id="our-service">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <h2 className="text-4xl font-bold text-center mb-12">
          How We Can Help
        </h2>

        {/* Services Overview */}
        <div className="flex flex-wrap justify-center gap-8">
          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center w-full md:w-1/4">
            <i className="fas fa-home text-5xl text-blue-500 mb-4"></i>
            <h3 className="text-2xl font-semibold mb-2">Market Analysis</h3>
            <p className="text-gray-600">
              We provide consulting services to help you understand your
              potential earnings.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center w-full md:w-1/4">
            <i className="fas fa-shield-alt text-5xl text-green-500 mb-4"></i>
            <h3 className="text-2xl font-semibold mb-2">
              Market Driven Pricing Strategy
            </h3>
            <p className="text-gray-600">
              We update your listing price 3 times a day based on real-time
              market information.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center w-full md:w-1/4">
            <i className="fas fa-star text-5xl text-yellow-500 mb-4"></i>
            <h3 className="text-2xl font-semibold mb-2">
              AI Powered Automation
            </h3>
            <p className="text-gray-600">
              Our AI-powered automation system creates a smooth experience for
              both guests and owners.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
